import { createSelector, MemoizedSelector } from '@ngrx/store';
import { Pos } from '@shop/const';
import { StateUtils } from '@spartacus/core';
import { ShopState, StateWithShop } from '../shop-state';
import { getShopState } from './feature.selector';

export const getShopListState: MemoizedSelector<StateWithShop, StateUtils.LoaderState<Pos[]>> = createSelector(
  getShopState,
  (state: ShopState) => state.shops,
);

export const getShopList: MemoizedSelector<StateWithShop, Pos[]> = createSelector(
  getShopListState,
  (state: StateUtils.LoaderState<Pos[]>) => {
    return StateUtils.loaderValueSelector(state);
  },
);

export const getShopListLoading: MemoizedSelector<StateWithShop, boolean> = createSelector(
  getShopListState,
  (state: StateUtils.LoaderState<Pos[]>) => StateUtils.loaderLoadingSelector(state),
);

export const getShopListSuccess: MemoizedSelector<StateWithShop, boolean> = createSelector(
  getShopListState,
  (state: StateUtils.LoaderState<Pos[]>) => StateUtils.loaderSuccessSelector(state),
);

export const getShopListError: MemoizedSelector<StateWithShop, boolean> = createSelector(
  getShopListState,
  (state: StateUtils.LoaderState<Pos[]>) => StateUtils.loaderErrorSelector(state),
);

export const getShop = (id?: string): MemoizedSelector<StateWithShop, Pos> =>
  createSelector(getShopList, (shops: Pos[]) =>
    id && shops ? shops.find((shop: Pos) => shop.name === id) : undefined,
  );
